module.exports = __webpack_public_path__ + "2960ea9c37417fd65b03815f2a8f882d.svg";